import PropTypes from "prop-types";
import { Input, Form } from "antd";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const UserEmail = ({ form, name, value, disabled, users = [], label, layout = "vertical" }) => {
    const [t] = useTranslation();

    const emails = useMemo(() => users.map(user => user.email), [users]);

    return (
        <Form form={form} initialValues={{ [name]: value }} disabled={disabled} layout={layout}>
            <Form.Item
                name={name}
                label={t(label)}
                rules={[
                    {
                        type: "email",
                        required: true,
                        message: t("t_user_email_is_required")
                    },
                    {
                        message: t("t_user_email_already_taken"),
                        validator: (_, currentValue) => {
                            if (currentValue === value) return Promise.resolve();
                            return emails.includes(currentValue) ? Promise.reject() : Promise.resolve();
                        }
                    }
                ]}
            >
                <Input placeholder={t("t_user_email")} style={{ width: "100%" }} disabled={disabled} />
            </Form.Item>
        </Form>
    );
};

UserEmail.propTypes = {
    form: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.bool
};

export default UserEmail;
